<template>
   <v-layout
   flex-child
      wrap
      style="height:100vh;overflow:hidden !important">
    <v-flex xs12 md10>

      <a href="https://www.smartpress.co/"><img
      v-if="!$vuetify.breakpoint.smAndDown"
        src="../../assets/logo.png"
        height="45px"
        @click="window.location.replace('https://www.smartpress.co')"
        style="position:absolute;left:30px;top:20px;margin-left:0px;cursor:pointer;  "
      ></a>
        <div v-if="!$vuetify.breakpoint.smAndDown" style="width:300px;transform: translateX(40%) translateY(160px);">
          <h2><v-icon medium style="margin-right:10px">account_circle</v-icon>Sign In</h2>
          <p>to Smartpress</p>
              <v-text-field 
                id="usernameInput" 
                v-model="username"
                required
                placeholder="Enter username or email"/>
              <v-text-field 
                type="password"
                id="enter"
                v-model="pass"
                required
                placeholder="Enter Password"/>
            <b-button 
              type="submit" 
              
              variant="primary"
              @click="signIn"
              v-on:keyup.enter="signIn">Submit</b-button>
 
            <br/><br/>
          <b-link @click="signupPage()">Create account</b-link> or <b-link to="../passwordReset">reset password</b-link>
    sws
          <GoogleLogin :params="params" :renderParams="renderParams" :onSuccess="onSuccess" :onFailure="onFailure"></GoogleLogin>


           <v-alert/>
           <DialogLoader :dialog="loadingActive"></DialogLoader>
        </div>

        <div style="width:80%;margin:40px;" v-if="$vuetify.breakpoint.smAndDown">
           <img
        src="../../assets/logo.png"
        height="25px"
        style="margin-bottom:16px;"
      >
          <h2><v-icon medium style="margin-right:10px">account_circle</v-icon>Sign In</h2>
          <p>to Smartpress</p>
              <v-text-field 
                id="usernameInput" 
                v-model="username"
                required
                placeholder="Enter username or email"/>
              <v-text-field 
                type="password"
                id="enter"
                v-model="pass"
                required
                placeholder="Enter Password"/>
            <b-button 
              type="submit" 
              
              variant="primary"
              @click="signIn"
              v-on:keyup.enter="signIn">Submit</b-button>
 
            <br/><br/>

          <b-link @click="signupPage()">Create account</b-link> or <b-link to="../passwordReset">reset password</b-link>
           <v-alert></v-alert>

 
           <DialogLoader :dialog="loadingActive"></DialogLoader>
        </div>
     
     
          
   
 
       
   
    
 </v-flex>
   <v-flex style="background-color:#5764E4" v-if="!$vuetify.breakpoint.smAndDown"   xs2> 
          <img
          
          src="../../assets/Art/plants.svg"
          height="405px"
           
          style="position:absolute;right:90px;top:40vh;margin-left:0px;cursor:pointer; "
        >
      </v-flex>
  </v-layout>
</template>

<script>
import Vue from "vue"
import { mapGetters } from "vuex"
import router from "@/router"
import store from "@/store"
import GoogleLogin from 'vue-google-login';

import Alert from "@/components/auth/Alert.vue"

import DialogLoader from "@/components/loading/dialogLoader.vue"

Vue.component("v-alert", Alert)

export default {
  data() {
    return {
      username: "",
      pass: "",
      loadingActive: false,
     
      // client_id is the only required property but you can add several more params, full list down bellow on the Auth api section
      params: {
          client_id: "805328997457-g1vb3o1ngrfdrfc88to5f6ehspa3in9f.apps.googleusercontent.com"
      },
      // only needed if you want to render the button with the google ui
      renderParams: {
          width: 250,
          height: 50,
          longtitle: true
      }
            
    }
  },
  components: {
    GoogleLogin,
    DialogLoader
  },
  computed: {
    ...mapGetters("auth", ["hasAuthenticationStatus"])
  },
  mounted: function () {
    // Get the input field
    var input = document.getElementById("enter");
    let self = this
    // Execute a function when the user releases a key on the keyboard
    input.addEventListener("keyup", function(event) {
      // Number 13 is the "Enter" key on the keyboard
      if (event.keyCode === 13) {
        // Cancel the default action, if needed
        event.preventDefault();
        // Trigger the button element with a click
        self.signIn()
      }
    });
  },
  methods: {
    signupPage: function () {
      router.push({name: 'signUp', params: { incomingUserType: this.$route.params.incomingUserType }})
    },
    homePage: function () {
      window.location.replace('https://www.smartpress.co')
    },
    async signIn() {
      this.loadingActive = true

      await store.dispatch("auth/signIn", {
        username: this.username.toLowerCase(),
        password: this.pass
      })

      // setTimeout(() => {
      //   if (self.myContracts.Count == 0 && self.$route.params.incomingUserType == 'contract') {
      //     self.$router.push({name: 'createContract'})
      //   }
      // }, 1000)

      

      if (!this.hasAuthenticationStatus) {
        console.log(this.$cookies.get('afterLoginGoToTokenDetail'))
        if (this.$cookies.get('afterLoginGoToTokenDetail') == 'true') {
          window.location.pathname = '../../contractDetail/token'
        } else if (this.$cookies.get('newSignup') == 'true') {
          this.$router.push({name: 'createContract'})
        } else {
          window.location.pathname = '/myContracts/' + this.$route.params.incomingUserType

          // router.push({name: 'myContractsNewUser', params: { incomingUserType: this.$route.params.incomingUserType }})
        }
      } else {
        this.loadingActive = false
      }
    }
  }
}
</script>

<style>
::-webkit-scrollbar {
    width: 0px;
    background: transparent; /* make scrollbar transparent */
}




</style>
